import { render } from "./ItemDetail.vue?vue&type=template&id=b54da520&scoped=true"
import script from "./ItemDetail.vue?vue&type=script&lang=js"
export * from "./ItemDetail.vue?vue&type=script&lang=js"

import "./ItemDetail.vue?vue&type=style&index=0&id=b54da520&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b54da520"]])

export default __exports__